import ReactCountryFlag from 'react-country-flag';

import { LANGUAGE_FLAGS, SupportedLanguages } from 'i18n/i18n';

export type FlagProps = {
   lang: SupportedLanguages;
};

export const Flag = ({ lang }: FlagProps) => {
   const parsed = (lang.split('-').at(0) || 'en') as SupportedLanguages;

   return (
      <ReactCountryFlag countryCode={LANGUAGE_FLAGS[parsed]} svg style={{ alignSelf: 'center' }} />
   );
};
